/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PERMISSIONS } from '@squiz/dxp-auth';
import { ICON_AIRLINE_STOPS, ICON_AUTO_FIX_HIGH, ICON_MISCELLANEOUS_SERVICES, ICON_PENDING_ACTIONS } from '@squiz/sds';
import { AI_STRINGS } from 'apps/artificial-intelligence/src/Constants/Strings.constants';
import { DashboardCardProps } from 'apps/console-core/src/Components/DashboardCard/DashboardCard.props';
import { TENANT_FEATURE_FLAGS } from 'apps/console-core/src/Constants/FeatureFlags.constants';
import { ICON_ALT_ROUTE, ICON_FOLDER_ZIP } from 'libs/sds/src/Icons';
import { screenPaths } from './ScreenPaths.constants';
import { CONFIGURATION_STRINGS } from './Strings.constants';

export const AI_CONTENT_TOOLS_DASHBOARD_CARD: DashboardCardProps = {
  description: AI_STRINGS.aiContentToolsDescription,
  featureFlag: TENANT_FEATURE_FLAGS.CONTENT_TOOLS_ACCESS,
  icon: ICON_AUTO_FIX_HIGH,
  link: screenPaths.aiContentTools,
  permission: PERMISSIONS.dxpAi.GENERATIVE_READ,
  title: AI_STRINGS.aiContentTools,
};

export const JOB_RUNNER_DASHBOARD_CARD: DashboardCardProps = {
  description: CONFIGURATION_STRINGS.jobRunnerDescription,
  featureFlag: TENANT_FEATURE_FLAGS.JOB_RUNNER_ACCESS,
  icon: ICON_PENDING_ACTIONS,
  link: screenPaths.jobRunner,
  permission: PERMISSIONS.dxpJobRunner.JOB_READ,
  title: CONFIGURATION_STRINGS.jobRunner,
};

export const SERVICE_SETTINGS_DASHBOARD_CARD: DashboardCardProps = {
  description: CONFIGURATION_STRINGS.serviceSettingsDescription,
  icon: ICON_MISCELLANEOUS_SERVICES,
  link: screenPaths.serviceSettings,
  title: CONFIGURATION_STRINGS.serviceSettings,
};

export const EVENT_SERVICE_DASHBOARD_CARD: DashboardCardProps = {
  description: CONFIGURATION_STRINGS.eventServiceDescription,
  icon: ICON_AIRLINE_STOPS,
  link: screenPaths.eventService,
  permission: PERMISSIONS.dxpEventBus.EVENT_BUS_SUBSCRIPTION_READ,
  title: CONFIGURATION_STRINGS.eventService,
};

export const DAM_INTEGRATIONS_CARD: DashboardCardProps = {
  description: CONFIGURATION_STRINGS.damIntegrationsDescription,
  featureFlag: TENANT_FEATURE_FLAGS.DAM_INTEGRATIONS_ACCESS,
  icon: ICON_FOLDER_ZIP,
  link: screenPaths.damIntegrations,
  permission: PERMISSIONS.dxpEventBus.EVENT_BUS_SUBSCRIPTION_READ,
  title: CONFIGURATION_STRINGS.damIntegrationsTitle,
};

export const STATIC_SITES_DASHBOARD_CARD: DashboardCardProps = {
  description: CONFIGURATION_STRINGS.staticRoutingDescription,
  icon: ICON_ALT_ROUTE,
  link: screenPaths.staticSites,
  title: CONFIGURATION_STRINGS.staticSites,
};

export const CONFIGURATION_DASHBOARD_CARDS = [
  AI_CONTENT_TOOLS_DASHBOARD_CARD,
  DAM_INTEGRATIONS_CARD,
  EVENT_SERVICE_DASHBOARD_CARD,
  JOB_RUNNER_DASHBOARD_CARD,
  SERVICE_SETTINGS_DASHBOARD_CARD,
  STATIC_SITES_DASHBOARD_CARD,
];
